import React, { useState } from 'react';
import { ModalHeader, ModalBody } from 'reactstrap';

import { ModalContainer, ModalTitle, CancelButton } from '../../../components/Modals/styles';
import DepartmentSetting from '../../components/DepartmentSetting';

export default React.memo(({ createDepartment, closeModal }) => {
  const [isOpen, setIsOpen] = useState(true);

  const hideModal = () => {
    setIsOpen(false);
    return closeModal && closeModal();
  };

  return (
    <ModalContainer isOpen={isOpen} autoFocus={false}>
      <ModalHeader>
        <ModalTitle>Add New Department</ModalTitle>
        <CancelButton onClick={() => hideModal()}>
          <i className="fa fa-times" aria-hidden="true"></i>
        </CancelButton>
      </ModalHeader>
      <ModalBody>
        <DepartmentSetting isModal department={{}} createDepartment={createDepartment} />
      </ModalBody>
    </ModalContainer>
  );
});
